import React, { PureComponent } from 'react'
import { Panel, Row } from 'react-bootstrap'
import InputSelect from '../../../components/commons/form/InputSelect'
import InputMoney from '../../../components/commons/form/InputMoney'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import InputPercentage from '../../../components/commons/form/InputPercentage'
import { Field } from 'redux-form'
import { validateDate } from '../../../util/validationFunctions'
import CustomFields from '../../../components/commons/customFields/CustomFields'
import ComponentTitle from '../../../containers/dossiers/commons/ComponentTitlePage'
import { NUMBER_OF_DECIMALS, MAX_LENGTH_PERCENTAGE } from '../../../constants/dossier/common/economicPlanSection'
import { iemValues } from '../../../constants/backendIds'

class SaleExport extends PureComponent {
  constructor () {
    super()
    this.state = {
      open: false,
      dataLoaded: false,
      loaded: false,
      valueIem: null
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.open && prevProps.open === false) {
      this.setState({ open: true })
    }
    if (this.props.isFinanceLoaded === false && this.state.open) {
      this.setState({ loaded: true })
    }

    if (prevProps?.dossier?.dossierSaleExportationComponent?.updated === false && this.props.dossier?.dossierSaleExportationComponent?.updated === true) {
      this.setState({ valueIem: { valueIem: this.props.dossier?.dossierSaleExportationComponent?.iemTypeId } })
    }
    return null
  }

  componentDidUpdate () {
    if (this.state.loaded) {
      this.setState({ loaded: false })
      if (this.props.historical === false) {
        return new Promise((resolve, reject) => {
          this.props.handleToUpdateComponent(this.props)
          return this.props.actions.fetchSalesExport(this.props.dossierId, resolve, reject, this.props.pristine)
        })
      } else {
        return new Promise((resolve, reject) => {
          this.props.handleToUpdateComponent(this.props)
          return this.props.actions.fetchSalesExportHistorical(this.props.dossierId, resolve, reject)
        })
      }
    }
    if (!this.state.dataLoaded && this.props.dossier?.dossierSaleExportationComponent) {
      if (Object.keys(this.props.dossier?.dossierSaleExportationComponent).length > 1) {
        this.setState({ dataLoaded: true })
      }
    }
  }

  fetchSalesDossierPromiseExport () {
    if (this.state.open) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({
      open: !this.state.open
    })

    if (this.props.dossierId !== -1) {
      if (this.props.isSalesExportLoaded === false || (this.props.isSalesExportLoaded && this.state.dataLoaded === false)) {
        if (this.props.historical === false) {
          return new Promise((resolve, reject) => {
            this.props.handleToUpdateComponent(this.props)
            return this.props.actions.fetchSalesExport(this.props.dossierId, resolve, reject, this.props.pristine)
          })
        } else {
          return new Promise((resolve, reject) => {
            this.props.handleToUpdateComponent(this.props)
            return this.props.actions.fetchSalesExportHistorical(this.props.dossierId, resolve, reject)
          })
        }
      }
    }
  }

  dateValidation (value, allValues, props) {
    const result = validateDate(value, props)
    return result === Object(result) ? undefined : result
  }

  calculateIem (iemValue) {
    this.setState({ amountIem: (parseFloat(iemValue)), iemPercentage: iemValue })
  }

  calculateIemTax (valueIem) {
    this.setState({ valueIem })

    if (valueIem && valueIem.valueIem !== iemValues.other) {
      var value = this.props.combos.iemType.find((item) => item.id === valueIem.valueIem)?.amountValue || 0
      this.props.change('dossierSaleExportationComponent.iemTax', value)
    } else if (valueIem === null || valueIem === undefined) {
      this.props.change('dossierSaleExportationComponent.iemTax', null)
    }
  }

  render () {
    const {
      t, readOnlyFields, combos: { iemType }, customFields
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.SALE_EXPORT.'

    return (
      <Row className="dossier-Component">
        <div className="header-panel" onClick={this.fetchSalesDossierPromiseExport.bind(this)} id="saleExport_panel">
          <ComponentTitle
            componentCode="SALES_EXPORT"
            componentOpen={this.state.open}
          />
        </div>
        <Panel expanded={this.state.open} onToggle={() => {}}>
          <Panel.Collapse>
            <Row className={'saleExportRow'}>
              <Row>
                <Field
                  id="saleExport_pvpVn"
                  name="dossierSaleExportationComponent.pvpVn"
                  controlLabel={t(`${tKey}PVP_VN`)}
                  placeholder={t(`${tKey}PVP_VN`)}
                  component={InputMoney}
                  disabled={readOnlyFields}
                  colSm={4}
                />
                <Field
                  id="saleExport_pvpVo"
                  name="dossierSaleExportationComponent.pvpVo"
                  controlLabel={t(`${tKey}PVP_VO`)}
                  placeholder={t(`${tKey}PVP_VO`)}
                  component={InputMoney}
                  disabled={true}
                  colSm={4}
                />
                <Field
                  id="saleExport_pvpTreasury"
                  name="dossierSaleExportationComponent.pvpTreasury"
                  controlLabel={t(`${tKey}PVP_TREASURY`)}
                  placeholder={t(`${tKey}PVP_TREASURY`)}
                  component={InputMoney}
                  disabled={readOnlyFields}
                  colSm={4}
                />
              </Row>
              <Row>
                <Field
                  id="saleExport_iemTypeId"
                  name="dossierSaleExportationComponent.iemTypeId"
                  controlLabel={t(`${tKey}IEM_TYPE`)}
                  placeholder={t(`${tKey}IEM_TYPE`)}
                  component={InputSelect}
                  options={iemType}
                  valueKey="id"
                  labelKey="value"
                  disabled={readOnlyFields}
                  colSm={6}
                  onInputChange={(valueIem) => this.calculateIemTax({ valueIem })}
                />
                <Field
                  id="saleExport_iemTax"
                  name="dossierSaleExportationComponent.iemTax"
                  controlLabel={t(`${tKey}IEM_TAX`)}
                  placeholder={t(`${tKey}IEM_TAX`)}
                  component={InputPercentage}
                  disabled={readOnlyFields || this.state.valueIem?.valueIem !== iemValues.other}
                  colSm={6}
                  customClass="iem-percentage"
                  decimals={NUMBER_OF_DECIMALS}
                  maxLength={MAX_LENGTH_PERCENTAGE}
                  onBlur={(iemPercentage) => { this.calculateIem(iemPercentage.target.value) }}
                />
              </Row>
              <Row>
                <Field
                  id="saleExport_licenseDate"
                  name="dossierSaleExportationComponent.licenseDate"
                  controlLabel={t(`${tKey}LICENSE_DATE`)}
                  placeholder={t(`${tKey}LICENSE_DATE`)}
                  component={InputDatePicker}
                  disabled={true}
                  colSm={6}
                />
                <Field
                  id="saleExport_dischargeDate"
                  name="dossierSaleExportationComponent.dischargeDate"
                  controlLabel={t(`${tKey}DISCHARGE_DATE`)}
                  placeholder={t(`${tKey}DISCHARGE_DATE`)}
                  component={InputDatePicker}
                  disabled={readOnlyFields || (this.props.dossier?.dossierSaleExportationComponent?.licenseDate === null || this.props.dossier?.dossierSaleExportationComponent?.licenseDate === undefined)}
                  validate={[this.dateValidation]}
                  colSm={6}

                />
              </Row>
              <Row>
                <Field
                  id="saleExport_depreciationPercentage"
                  name="dossierSaleExportationComponent.depreciationPercentage"
                  controlLabel={t(`${tKey}DEPRECIATION_PERCENTAGE`)}
                  placeholder={t(`${tKey}DEPRECIATION_PERCENTAGE`)}
                  component={InputPercentage}
                  disabled={true}
                  colSm={4}
                />
                <Field
                  id="saleExport_depreciation"
                  name="dossierSaleExportationComponent.depreciation"
                  controlLabel={t(`${tKey}DEPRECIATION`)}
                  placeholder={t(`${tKey}DEPRECIATION`)}
                  component={InputMoney}
                  disabled={true}
                  colSm={4}
                />
                <Field
                  id="saleExport_refundAmount"
                  name="dossierSaleExportationComponent.refundAmount"
                  controlLabel={t(`${tKey}REFUND_AMOUNT`)}
                  placeholder={t(`${tKey}REFUND_AMOUNT`)}
                  component={InputMoney}
                  disabled={true}
                  colSm={4}
                />
              </Row>
            </Row>
            <CustomFields customFields={customFields} readOnlyFields={readOnlyFields} />
          </Panel.Collapse>
        </Panel>
      </Row>

    )
  }
}
export default SaleExport
